export const VALID_AREA_CODE = 'VALID_AREA_CODE'
export const NOT_VALID_AREA_CODE = 'NOT_VALID_AREA_CODE'

export const SET_CUSTOMER_TYPE = 'SET_CUSTOMER_TYPE'
